<template>
  <div class="d-flex align-center">
    <div
      :class="{
        'square-legend': true,
        'square-legend--border': bordered,
      }"
      :style="`background-color: ${backgroundColor}`"
    ></div>
    <span class="ml-3"><slot /></span>
  </div>
</template>

<script>
export default {
  name: 'SquareLegend',
  props: {
    bordered: {
      type: Boolean,
      default: false,
      required: false,
    },
    backgroundColor: {
      type: String,
      default: '#fff',
      required: false,
    },
  },
};
</script>

<style lang="scss">
.square-legend {
  width: 30px;
  height: 30px;
}

.square-legend--border {
  border: 1px solid #000;
}
</style>
